import { useMemo } from 'react';

import { useGraphVizContext } from '../graph-viz-context';
import { DetailsPanel } from './details-panel';
import { OverviewPanel } from './overview-panel';

export function SingleSelectionSidepanelContents() {
  const { selected } = useGraphVizContext();

  const hasSelection = useMemo(() => selected.nodeIds.length > 0 || selected.relationshipIds.length > 0, [selected]);

  return hasSelection ? <DetailsPanel /> : <OverviewPanel />;
}
